'use client';

import { FormInput } from '@form/index';
import { useTranslation } from 'react-i18next';

/** Where the money goes — shown whether or not a bank account is connected. */
const BankDetails = () => {
    const { t } = useTranslation('invoice');

    return (
        <div className="tw-grid tw-gap-2 md:tw-grid-cols-2">
            <FormInput.IBAN name="iban" label={t('invoiceList.externalImport.fields.iban')} />
            <FormInput name="bic" label={t('invoiceList.externalImport.fields.bic')} />
        </div>
    );
};

export default BankDetails;
